import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import { useAppState } from '../state/app-state';

export function ToastStack() {
  const { toasts } = useAppState();
  return (
    <div className="toast-stack" aria-live="polite">
      {toasts.map((toast) => {
        const Icon = toast.tone === 'success' ? CheckCircle2 : toast.tone === 'error' ? AlertCircle : Info;
        return <div key={toast.id} className={`toast toast--${toast.tone}`}><Icon size={20} />{toast.message}</div>;
      })}
    </div>
  );
}
